import { ParticipantsPersonBlockEventsApi } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo } from 'react';

import { useApiConfiguration } from '@/features/api/hooks/useApiConfiguration';

export const useParticipantPersonBlockEventsApi = () => {
  const configuration = useApiConfiguration();
  return useMemo(
    () => new ParticipantsPersonBlockEventsApi(configuration),
    [configuration]
  );
};
